
export default function Experience() {
  const experiences = [
    {
      company: 'Sureworx',
      period: '2022 – Present',
      role: 'UI/UX Designer',
      description: 'Conducting user research, personas, journey maps, prototypes, accessible UI (WCAG), design systems, and AI-driven UX solutions across enterprise products.',
      color: 'blue'
    },
    {
      company: 'Wipro',
      period: '2016 – 2022',
      role: 'Senior UI Designer / Developer',
      description: 'Handled entire product UX cycle: research → wireframes → high-fidelity UI → development collaboration.',
      color: 'teal'
    },
    {
      company: 'Magna Infotech – Wipro',
      period: '2012 – 2016',
      role: 'UI Designer / Developer',
      description: 'Requirement analysis, competitor studies, sketches, wireframes, UI design, frontend HTML/CSS/JS delivery.',
      color: 'blue'
    },
    {
      company: 'Mobifusion',
      period: '2011 – 2012',
      role: 'Graphic Designer',
      description: 'Created splash screens, game UI, internal screens, mobile flows, HTML/CSS websites, brochures, flyers.',
      color: 'teal'
    }
  ];

  return (
    <section id="experience" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Experience Timeline</h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto"></div>
        </div>

        <div className="relative">
          <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-gray-300 hidden md:block"></div>
          
          <div className="space-y-12">
            {experiences.map((exp, index) => (
              <div key={index} className={`relative flex items-center ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                <div className={`w-full md:w-5/12 ${index % 2 === 0 ? 'md:text-right md:pr-12' : 'md:text-left md:pl-12'}`}>
                  <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                    <div className="flex items-center gap-3 mb-3">
                      <div className={`w-3 h-3 rounded-full ${exp.color === 'blue' ? 'bg-blue-600' : 'bg-teal-600'}`}></div>
                      <span className="text-sm font-semibold text-gray-500">{exp.period}</span>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">{exp.company}</h3>
                    <h4 className="text-lg font-semibold text-blue-600 mb-3">{exp.role}</h4>
                    <p className="text-gray-600 leading-relaxed">{exp.description}</p>
                  </div>
                </div>
                
                <div className="absolute left-1/2 transform -translate-x-1/2 w-4 h-4 rounded-full bg-blue-600 border-4 border-white shadow-lg hidden md:block"></div>
                
                <div className="w-full md:w-5/12"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
